import { DetailViewConfig } from '../../../app/config/model/detailview-config.model';
import { Workspace } from '../../../app/shared/enum/workspace.enum';
import { LayerCode } from '../../../app/shared/enum/layer-code.enum';

export const DETAIL_VIEW_CONFIG: DetailViewConfig = {
  detailviews: [
    {
      fkArbeitsbereich: Workspace.sbb_eigentumsflaeche,
      fkIdentifyLayer: LayerCode.parzellen,
      forms: [
        {
          fkIdentifyLayerId: 0,
          editable: false,
          attributeTitle: 'PARZNR',
          detailViewTitle: 'IDENTIFY_CONFIG.PARZELLE',
          editableLayerId: LayerCode.f_parzellen,
          partFeaturesTable: {
            queryAttribute: 'PARZELLE_SAPID',
            joinAttribute: 'PARZELLE_SAPUID',
            layerId: 1,
            columns: [
              {
                name: 'JSON_CONFIG.DETAIL_VIEW.ANLAGE_NR',
                prop: 'attributes.ANLAGE_NR',
                width: 78,
              },
              {
                name: 'JSON_CONFIG.DETAIL_VIEW.INVENTAR_NR',
                prop: 'attributes.OBJEKTNR',
                width: 168,
              },
              {
                name: 'JSON_CONFIG.DETAIL_VIEW.FLAECHE',
                prop: 'attributes.FLAECHE_AUSGEGLICHEN',
                width: 82,
                round: true,
              },
              {
                name: 'JSON_CONFIG.DETAIL_VIEW.GIS_FLAECHE',
                prop: 'attributes.FLAECHE_BERECHNET',
                width: 82,
                round: false,
                float: 1,
              },
              {
                name: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BUCHUNGSKREIS',
                prop: 'attributes.BUCHUNGSKREIS',
                width: 100,
              },
            ],
          },
          formFields: [
            {
              EIGENTUM: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EIGENTUM',
              editable: false,
              required: false,
              component: 'selectbox',
            },
            {
              GEMEINDE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GEMEINDE',
              editable: false,
            },
            {
              PARZNR: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.PARZNR',
              editable: false,
              required: false,
            },
            {
              EGRID: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EGRID',
              editable: false,
              required: false,
            },
            {
              AOID_GR: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.AOID_GR',
              editable: false,
              required: false,
            },
            {
              FLAECHE_BERECHNET: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.FLAECHE_BERECHNET',
              editable: false,
              required: false,
              float: 1,
            },
            {
              FLAECHE_AUSGEGLICHEN: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.FLAECHE_AUSGEGLICHEN',
              editable: false,
              required: false,
              float: 1,
            },
            {
              EASTING: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EASTING',
              editable: false,
              float: 0,
            },
            {
              NORTHING: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.NORTHING',
              editable: false,
              required: false,
              float: 0,
            },
            {
              LINIE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.LINIE',
              editable: false,
              required: false,
            },
            {
              KM_ANF: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.KM_ANF',
              editable: false,
              required: false,
              float: 3,
            },
            {
              KM_ENDE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.KM_ENDE',
              editable: false,
              required: false,
              float: 3,
            },
            {
              GEMEINDE_ARCHIVIERT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GEMEINDE_ARCHIVIERT',
              editable: false,
            },
          ],
        },
        {
          fkIdentifyLayerId: 1,
          editable: false,
          detailViewTitle: 'IDENTIFY_CONFIG.TEILPARZELLE',
          attributeTitle: 'ANLAGE_NR',
          editableLayerId: LayerCode.f_teilparzelle,
          formFields: [
            {
              GEMEINDE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GEMEINDE',
              editable: false,
            },
            {
              GEMEINDE_ARCHIVIERT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GEMEINDE_ARCHIVIERT',
              editable: false,
            },
            {
              PARZNR: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.PARZNR',
              editable: false,
              required: false,
            },
            {
              EIGENTUEMER_TYP: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EIGENTUEMER_TYP',
              editable: false,
              required: false,
              component: 'selectbox',
            },
            {
              EIGENTUMSART: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EIGENTUMSART',
              editable: false,
              required: false,
              component: 'selectbox',
            },
            {
              NUTZUNG_TYP: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.NUTZUNG_TYP',
              editable: false,
              required: false,
              component: 'selectbox',
            },
            {
              OBJEKTNR: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.OBJEKTNR',
              editable: false,
              required: false,
            },
            {
              AOID_TGR: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.AOID_GR',
              editable: false,
              required: false,
            },
            {
              ANLAGE_NR: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.ANLAGE_NR',
              editable: false,
              required: false,
            },
            {
              EASTING: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EASTING',
              editable: false,
              float: 3,
            },
            {
              NORTHING: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.NORTHING',
              editable: false,
              required: false,
              float: 3,
            },
            {
              FLAECHE_BERECHNET: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.FLAECHE_BERECHNET',
              editable: false,
              required: false,
              float: 1,
            },
            {
              FLAECHE_AUSGEGLICHEN: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.FLAECHE_AUSGEGLICHEN',
              editable: false,
              required: false,
              float: 0,
            },
          ],
        },
        {
          fkIdentifyLayerId: 3,
          editable: false,
          attributeTitle: 'PARZNR',
          detailViewTitle: 'IDENTIFY_CONFIG.PARZELLE_Dritt',
          editableLayerId: LayerCode.f_parzelleDritt,
          partFeaturesTable: {
            queryAttribute: 'PARZELLE_SAPID',
            joinAttribute: 'PARZELLE_SAPUID',
            layerId: 1,
            columns: [
              {
                name: 'JSON_CONFIG.DETAIL_VIEW.ANLAGE_NR',
                prop: 'attributes.ANLAGE_NR',
                width: 78,
              },
              {
                name: 'JSON_CONFIG.DETAIL_VIEW.INVENTAR_NR',
                prop: 'attributes.OBJEKTNR',
                width: 168,
              },
              {
                name: 'JSON_CONFIG.DETAIL_VIEW.FLAECHE',
                prop: 'attributes.FLAECHE_AUSGEGLICHEN',
                width: 82,
                round: true,
              },
              {
                name: 'JSON_CONFIG.DETAIL_VIEW.GIS_FLAECHE',
                prop: 'attributes.FLAECHE_BERECHNET',
                width: 82,
                round: false,
                float: 1,
              },
              {
                name: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BUCHUNGSKREIS',
                prop: 'attributes.BUCHUNGSKREIS',
                width: 100,
              },
            ],
          },
          formFields: [
            {
              EIGENTUM: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EIGENTUM',
              editable: false,
              required: false,
              component: 'selectbox',
            },
            {
              GEMEINDE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GEMEINDE',
              editable: false,
            },
            {
              PARZNR: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.PARZNR',
              editable: false,
              required: false,
            },
            {
              EGRID: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EGRID',
              editable: false,
              required: false,
            },
            {
              AOID_GR: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.AOID_GR',
              editable: false,
              required: false,
            },
            {
              FLAECHE_BERECHNET: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.FLAECHE_BERECHNET',
              editable: false,
              required: false,
              float: 1,
            },
            {
              FLAECHE_AUSGEGLICHEN: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.FLAECHE_AUSGEGLICHEN',
              editable: false,
              required: false,
              float: 1,
            },
            {
              EASTING: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EASTING',
              editable: false,
              float: 0,
            },
            {
              NORTHING: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.NORTHING',
              editable: false,
              required: false,
              float: 0,
            },
            {
              LINIE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.LINIE',
              editable: false,
              required: false,
            },
            {
              KM_ANF: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.KM_ANF',
              editable: false,
              required: false,
              float: 3,
            },
            {
              KM_ENDE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.KM_ENDE',
              editable: false,
              required: false,
              float: 3,
            },
            {
              GEMEINDE_ARCHIVIERT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GEMEINDE_ARCHIVIERT',
              editable: false,
            },
          ],
        },
      ],
    },
    {
      fkArbeitsbereich: Workspace.strategieflaechen,
      fkIdentifyLayer: LayerCode.strategieflaeche,
      forms: [
        {
          fkIdentifyLayerId: 6,
          editable: false,
          editableLayerId: LayerCode.f_public_strategieflaeche,
          detailViewTitle: 'POPUP.ARBEITSBEREICH.STRATEGIEFLAECHEN.TITLE',
          attributeTitle: 'ID_STRATEGIEWERT',
          formFields: [
            {
              ID: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.ID',
              editable: false,
              required: false,
            },
            {
              BEZEICHNUNG: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BEZEICHNUNG',
              editable: false,
              required: false,
            },
            {
              STRATEGIE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.STRATEGIE',
              editable: false,
              required: false,
              component: 'selectbox',
            },
            {
              BEGRUENDUNG_GRSTRAT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BEGRUENDUNG_GRSTRAT',
              editable: false,
              required: false,
            },
            {
              FLAECHE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.FLAECHE',
              editable: false,
              required: false,
            },
            {
              ZUGEH_EGRID: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.ZUGEH_EGRID',
              editable: false,
              required: false,
            },
            {
              LAUFZEIT_BAURECHT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.LAUFZEIT_BAURECHT',
              editable: false,
              required: false,
              component: 'datepicker',
            },
            {
              MUTATION_DATUM: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.MUTATION_DATUM',
              editable: false,
              required: false,
              component: 'datepicker',
            },
          ],
        },
      ],
    },
    {
      fkArbeitsbereich: Workspace.sap,
      fkIdentifyLayer: LayerCode.sap,
      forms: [
        {
          fkIdentifyLayerId: 12,
          editable: false,
          editableLayerId: LayerCode.f_public_refx_gb,
          attributeTitle: 'IM_SCHLUESSEL',
          detailViewTitle: 'POPUP.ARBEITSBEREICH.SAP.SAP_REFX_GEBAEUDE',
          formFields: [
            {
              IM_SCHLUESSEL: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.IM_SCHLUESSEL',
              editable: false,
              required: false,
            },
            {
              BUCHUNGSKREIS: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BUCHUNGSKREIS',
              editable: false,
              required: false,
            },
            {
              WIRTSCHAFTSEINHEIT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.WIRTSCHAFTSEINHEIT',
              editable: false,
              required: false,
            },
            {
              GEBAEUDE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GEBAEUDE',
              editable: false,
              required: false,
            },
            {
              GE_NUMMER_ALT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GE_NUMMER_ALT',
              editable: false,
              required: false,
            },
            {
              BEZEICHNUNG_DER_WE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BEZEICHNUNG_DER_WE',
              editable: false,
              required: false,
            },
            {
              BEZ_GEBAEUDE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BEZ_GEBAEUDE',
              editable: false,
              required: false,
            },
            {
              GEBAEUDEART: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GEBAEUDEART',
              editable: false,
              required: false,
            },
            {
              PLZ: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.PLZ',
              editable: false,
              required: false,
            },
            {
              GEMEINDE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GEMEINDE',
              editable: false,
              required: false,
            },
            {
              ORT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.ORT',
              editable: false,
              required: false,
            },
            {
              PROFITCENTER: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.PROFITCENTER',
              editable: false,
              required: false,
            },
            {
              KOORDINATE_E: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EASTING',
              editable: false,
              required: false,
            },
            {
              KOORDINATE_N: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.NORTHING',
              editable: false,
              required: false,
            },
          ],
        },
        {
          fkIdentifyLayerId: 13,
          editable: false,
          editableLayerId: LayerCode.f_public_refx_gr,
          attributeTitle: 'IM_SCHLUESSEL',
          detailViewTitle: 'POPUP.ARBEITSBEREICH.SAP.SAP_REFX_GRUNDSTUECK',
          formFields: [
            {
              IM_SCHLUESSEL: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.IM_SCHLUESSEL',
              editable: false,
              required: false,
            },
            {
              BUCHUNGSKREIS: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BUCHUNGSKREIS',
              editable: false,
              required: false,
            },
            {
              WIRTSCHAFTSEINHEIT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.WIRTSCHAFTSEINHEIT',
              editable: false,
              required: false,
            },
            {
              GRUNDSTUECK: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GRUNDSTUECK',
              editable: false,
              required: false,
            },
            {
              GR_NUMMER_ALT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GR_NUMMER_ALT',
              editable: false,
              required: false,
            },
            {
              BEZEICHNUNG_DER_WE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BEZEICHNUNG_DER_WE',
              editable: false,
              required: false,
            },
            {
              BEZ_GRUNDSTUECK: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BEZ_GRUNDSTUECK',
              editable: false,
              required: false,
            },
            {
              PLZ: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.PLZ',
              editable: false,
              required: false,
            },
            {
              GEMEINDE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.GEMEINDE',
              editable: false,
              required: false,
            },
            {
              ORT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.ORT',
              editable: false,
              required: false,
            },
            {
              PROFITCENTER: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.PROFITCENTER',
              editable: false,
              required: false,
            },
            {
              KOORDINATE_E: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EASTING',
              editable: false,
              required: false,
            },
            {
              KOORDINATE_N: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.NORTHING',
              editable: false,
              required: false,
            },
          ],
        },
      ],
    },
    {
      fkArbeitsbereich: Workspace.verkaufsobjekte,
      fkIdentifyLayer: LayerCode.verkaufsobjekte,
      forms: [
        {
          fkIdentifyLayerId: 9,
          editable: true,
          attributeTitle: 'ID_SAP',
          editableLayerId: LayerCode.f_verkaufsobjekte,
          detailViewTitle: 'POPUP.ARBEITSBEREICH.VERKAUF.VERKAUFSOBJEKTE',
          formFields: [
            {
              ID_SAP: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.ID_SAP',
              editable: true,
            },
            {
              EGRIS_EGRID: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EGRIS_EGRID',
              editable: true,
              max_length: 14,
            },
            {
              VERKAUFSOBJEKTART: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.VERKAUFSOBJEKTART',
              editable: true,
              required: false,
              component: 'selectbox',
            },
            {
              REFX_VERTRAGSNUMMER: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.REFX_VERTRAGSNUMMER',
              editable: true,
              required: false,
            },
            {
              BEMERKUNG: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BEMERKUNG',
              editable: true,
              required: false,
            },
            {
              ZUSTAENDIGE_PERSON: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.ZUSTAENDIGE_PERSON',
              editable: true,
              required: false,
            },
            {
              BAURECHT_STATUS: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BAURECHT_STATUS',
              editable: true,
              required: false,
              component: 'selectbox',
            },
            {
              BAURECHT_KATEGORIE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BAURECHT_KATEGORIE',
              editable: true,
              required: false,
              component: 'selectbox',
            },
            {
              FLAECHE_BERECHNET: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.FLAECHE_BERECHNET2',
              editable: false,
              required: false,
              float: 1,
            },
            {
              LINIE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.LINIE',
              editable: true,
              required: false,
            },
            {
              KM_ANF: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.KM_ANF',
              editable: false,
              required: false,
              float: 3,
            },
            {
              KM_ENDE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.KM_ENDE',
              editable: false,
              required: false,
              float: 3,
            },
            {
              EASTING: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EASTING',
              editable: false,
              required: false,
            },
            {
              NORTHING: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.NORTHING',
              editable: false,
              required: false,
            },
            {
              VERKAUFDATUM: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.VERKAUFDATUM',
              editable: true,
              required: false,
              component: 'datepicker',
            },
            {
              VERKAUFT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.VERKAUFT',
              editable: false,
              required: false,
              component: 'selectbox',
            },
          ],
        },
      ],
    },
    {
      fkArbeitsbereich: Workspace.nutzflaecheInfra,
      fkIdentifyLayer: LayerCode.nutzflaeche_infra,
      forms: [
        {
          fkIdentifyLayerId: 7,
          editable: false,
          attributeTitle: 'ORG_TEXT',
          detailViewTitle: 'POPUP.ARBEITSBEREICH.NUTZFLAECHEINFRA.TITLE',
          editableLayerId: LayerCode.f_public_nutzflaeche,
          formFields: [
            {
              ID_ORG_CL: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.ID_ORG_CL',
              editable: false,
              component: 'selectbox',
            },
            {
              ORT: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.ORT',
              editable: false,
              required: false,
            },
            {
              BEMERKUNG: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BEMERKUNG',
              editable: false,
              required: false,
            },
            {
              LINIE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.LINIE',
              editable: true,
              required: false,
            },
            {
              KM_ANF: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.KM_ANF',
              editable: false,
              required: false,
              float: 3,
            },
            {
              KM_ENDE: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.KM_ENDE',
              editable: false,
              required: false,
              float: 3,
            },
            {
              ID_LINKS_RECHTS_LINIE_CL:
                'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.ID_LINKS_RECHTS_LINIE_CL',
              editable: false,
              required: false,
              component: 'selectbox',
            },
            {
              ID_ART_UNVERKAEUFLICH_CL:
                'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.ID_ART_UNVERKAEUFLICH_CL',
              editable: false,
              required: false,
              component: 'selectbox',
            },
            {
              BEMERKUNG_UNVERK: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BEMERKUNG_UNVERK',
              editable: false,
              required: false,
            },
            {
              ID_ALTERNATIV_NUTZUNG_CL:
                'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.ID_ALTERNATIV_NUTZUNG_CL',
              editable: false,
              required: false,
              component: 'selectbox',
            },
            {
              BEMERKUNG_NUTZUNG: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.BEMERKUNG_NUTZUNG',
              editable: false,
              required: false,
            },
            {
              INFRA_LINK: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.INFRA_LINK',
              editable: false,
              required: false,
            },
          ],
        },
      ],
    },
    {
      fkArbeitsbereich: Workspace.areale,
      fkIdentifyLayer: LayerCode.areale_view,
      forms: [
        {
          fkIdentifyLayerId: 0,
          editable: false,
          attributeTitle: 'ORG_TEXT',
          detailViewTitle: 'POPUP.ARBEITSBEREICH.AREALE.TITLE',
          editableLayerId: LayerCode.f_public_areale,
          formFields: [
            {
              REFX_AOID_AR: 'JSON_CONFIG.DETAIL_VIEW.AREALE.REFX_AOID_AR',
              editable: false,
              required: false,
            },
            {
              REFX_BEZEICHNUNG: 'JSON_CONFIG.DETAIL_VIEW.AREALE.REFX_BEZEICHNUNG',
              editable: false,
              required: false,
            },
            {
              REFX_LAENDERCODE: 'JSON_CONFIG.DETAIL_VIEW.AREALE.REFX_LAENDERCODE',
              editable: false,
              required: false,
            },
            {
              INFRA_LINK: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.INFRA_LINK',
              editable: false,
              required: false,
            },
          ],
        },
      ],
    },
    {
      fkArbeitsbereich: Workspace.denkmalpflege,
      fkIdentifyLayer: LayerCode.denkmalpflege,
      forms: [
        {
          fkIdentifyLayerId: 5,
          attributeTitle: 'OBJEKTTITEL_EO',
          detailViewTitle: 'POPUP.ARBEITSBEREICH.ISBA.TITLE',
          editable: false,
          editableLayerId: LayerCode.f_isba_eo_report,
          formFields: [
            {
              ID_BAUBERATUNG: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.ID_BAUBERATUNG',
              editable: false,
              max_length: 75,
              component: 'selectbox',
            },
            {
              OBJEKTTITEL_EO: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.OBJEKTTITEL',
              editable: false,
              max_length: 75,
              component: 'textview',
            },
            {
              INVENTARNUMMER_EO: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.INVENTARNUMMER',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              GROUP_FIELD: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.ECKDATEN',
              groupId: 'group1',
              component: 'groupfields',
              formFields: [
                {
                  ADRESSE_STRASSE: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.ADRESSE_STRASSE',
                  component: 'textview',
                  editable: false,
                  max_length: 120,
                },
                {
                  ID_BETRIEBSPUNKT: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.ID_BETRIEBSPUNKT',
                  component: 'textviewbp',
                  editable: false,
                  max_length: 200,
                },
                {
                  POL_GEMEINDE: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.POL_GEMEINDE',
                  editable: false,
                  component: 'textview',
                  max_length: 200,
                },
                {
                  BAUTYP_EBENE_2B: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.ID_BAUTYP',
                  editable: false,
                  component: 'textview',
                  max_length: 200,
                  is_integer: true,
                },
                {
                  ID_BAUHERRSCHAFT: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.ID_BAUHERRSCHAFT',
                  editable: false,
                  component: 'textview',
                  max_length: 220,
                  is_integer: true,
                },
                {
                  ID_EIGENTUM: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.ID_EIGENTUM',
                  editable: false,
                  component: 'textview',
                  max_length: 220,
                  is_integer: true,
                },
                {
                  LINIE_DFA: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.LINIE_DFA',
                  editable: false,
                  component: 'textview',
                  max_length: 220,
                  is_integer: true,
                },
                {
                  ARCHITEKTNAME: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.ARCHITEKTNAME',
                  editable: false,
                  component: 'textview',
                  max_length: 100,
                },
                {
                  GLOBALID: 'JSON_CONFIG.DETAIL_VIEW.GLOBALID',
                  editable: false,
                  max_length: 270,
                  component: 'textview',
                },
              ],
            },
            { FOTO_LINK: '', editable: false, component: 'dmsimage', max_length: 1024 },
            {
              GROUP_FIELD: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.SCHUTZBEGRUENDUNG',
              groupId: 'group2',
              component: 'groupfields',
              formFields: [
                {
                  SCHUTZBEGRUENDUNG: '',
                  editable: false,
                  component: 'textviewarea',
                  max_length: 400,
                },
              ],
            },
            {
              GROUP_FIELD: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.EINSTUFUNGEN',
              groupId: 'group3',
              component: 'groupfields',
              formFields: [
                {
                  ID_EINSTUFUNG: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.ID_EINSTUFUNG',
                  editable: false,
                  max_length: 200,
                  component: 'textview',
                  is_integer: true,
                },
                {
                  INVENTAR_KGS: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.INVENTAR_KGS',
                  editable: false,
                  component: 'textview',
                  max_length: 200,
                  is_integer: true,
                },
                {
                  ISOS_PERIMETER: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.ISOS_PERIMETER',
                  editable: false,
                  component: 'textview',
                  max_length: 200,
                  is_integer: true,
                },
                {
                  ISOS_ERHALTUNGSZIEL: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.ISOS_ERHALTUNGSZIEL',
                  editable: false,
                  component: 'textview',
                  max_length: 200,
                  is_integer: true,
                },
                {
                  SBB_INVENTAR_BAERTSCHI:
                    'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.SBB_INVENTAR_BAERTSCHI',
                  editable: false,
                  component: 'textview',
                  is_integer: true,
                },
                {
                  INVENTAR_KANTON: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.INVENTAR_KANTON',
                  editable: false,
                  component: 'textview',
                  max_length: 1024,
                },
                {
                  INVENTAR_GEMEINDE: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.INVENTAR_GEMEINDE',
                  editable: false,
                  component: 'textview',
                  max_length: 1024,
                },
                {
                  UNTERSCHUTZSTELLUNG: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.UNTERSCHUTZSTELLUNG',
                  editable: false,
                  component: 'textview',
                  max_length: 1024,
                },
                {
                  GUTACHTEN_ANDERE: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.GUTACHTEN',
                  editable: false,
                  component: 'textview',
                  max_length: 1024,
                },
              ],
            },
          ],
        },
        {
          fkIdentifyLayerId: 40,
          attributeTitle: 'OBJEKTTITEL',
          detailViewTitle: 'POPUP.ARBEITSBEREICH.ISBA.TITLE',
          editable: false,
          editableLayerId: LayerCode.f_isba_ko_report,
          formFields: [
            {
              GROUP_FIELD: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_KU',
              groupId: 'group1',
              component: 'groupfields',
              formFields: [
                {
                  WE_TITEL: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_TITEL',
                  editable: false,
                  max_length: 200,
                  component: 'textview',
                },
                {
                  KU_LEBENSDATEN: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.KU_LEBENSDATEN',
                  editable: false,
                  max_length: 200,
                  component: 'textview',
                },
              ],
            },
            { FOTO_LINK: '', editable: false, component: 'dmsimage', max_length: 1024 },

            {
              GROUP_FIELD: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WERKINFO',
              groupId: 'group2',
              component: 'groupfields',
              formFields: [
                {
                  WE_DATIERUNG_VON: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_DATIERUNG_VON',
                  component: 'textview',
                  max_length: 200,
                  editable: false,
                },
                {
                  WE_WERKWUERDIGUNG: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_WERKWUERDIGUNG',
                  editable: false,
                  component: 'textview',
                  max_length: 200,
                },
                {
                  WE_DENKMALSCHUTZ: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_DENKMALSCHUTZ',
                  editable: false,
                  component: 'textview',
                  max_length: 400,
                  is_integer: true,
                },
                {
                  WE_EIGENTUM: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_EIGENTUM',
                  editable: false,
                  component: 'textview',
                  max_length: 200,
                  is_integer: true,
                },
                {
                  WE_ZUSTAND: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_ZUSTAND',
                  editable: false,
                  component: 'textview',
                  max_length: 200,
                  is_integer: true,
                },
                {
                  WE_ZUSTAND_MASSNAHMEN:
                    'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_ZUSTAND_MASSNAHMEN',
                  editable: false,
                  component: 'textview',
                  max_length: 400,
                  is_integer: true,
                },
                {
                  WE_MA_DRINGLICHKEIT: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_MA_DRINGLICHKEIT',
                  editable: false,
                  component: 'textview',
                  max_length: 400,
                },
                {
                  WE_NAECHSTE_KONTROLLE:
                    'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_NAECHSTE_KONTROLLE',
                  editable: false,
                  component: 'datepicker',
                },
                {
                  WE_NAECHSTE_KONTROLLE_BEMERKUNG:
                    'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_NAECHSTE_KONTROLLE_BEMERKUNG',
                  editable: false,
                  component: 'textview',
                  max_length: 400,
                },
                {
                  WE_AUSSTELLUNG_PRAESENTATION:
                    'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_AUSSTELLUNG_PRAESENTATION',
                  editable: false,
                  component: 'textview',
                  max_length: 400,
                },
                {
                  WE_ERHALT_PFLEGE: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_ERHALT_PFLEGE',
                  editable: false,
                  component: 'textview',
                  max_length: 400,
                },
                {
                  WE_DPF_RISIKEN: 'JSON_CONFIG.DETAIL_VIEW.DENKMALPFLEGE.WE_DPF_RISIKEN',
                  editable: false,
                  component: 'textview',
                  max_length: 400,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      fkArbeitsbereich: Workspace.gebaeude,
      fkIdentifyLayer: LayerCode.gebaeude,
      forms: [
        {
          fkIdentifyLayerId: 12706,
          attributeTitle: 'GEBAEUDETYP',
          detailViewTitle: 'POPUP.ARBEITSBEREICH.GEBAEUDE.TITLE',
          editable: false,
          editableLayerId: LayerCode.f_gebaeude,
          formFields: [
            {
              GEBAEUDETYP: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.GEBAEUDETYP',
              editable: false,
              component: 'textview',
            },
            {
              ANLAGEKLASSE: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.ANLAGEKLASSE',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              STRASSENNAME: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.STRASSENNAME',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              HAUSNUMMER: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.HAUSNUMMER',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              POSTLEITZAHL: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.POSTLEITZAHL',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              ORTSCHAFT: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.ORTSCHAFT',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              GEMEINDENAME: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.GEMEINDENAME',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              GEMEINDENUMMER: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.GEMEINDENUMMER',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              REGION: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.REGION',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              EGID: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.EGID',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              BEZEICHNUNG: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.BEZEICHNUNG',
              editable: false,
              max_length: 75,
              component: 'textview',
            },
            {
              GEAENDERTAM: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.AENDERUNGSDATUM_UTC',
              editable: false,
              max_length: 20,
              component: 'datepicker',
            },
            {
              KOSTENSTELLE_NUMMER: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.KOSTENSTELLE_NUMMER',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              KOSTENSTELLE_ABKUERZUNG: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.KOSTENSTELLE_ABKUERZUNG',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              KOSTENSTELLE_BESCHREIBUNG:
                'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.KOSTENSTELLE_BESCHREIBUNG',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              EIGENTUEMER_DE: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.EIGENTUEMER_CD',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              FID: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.FEATUREID',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              IPID: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.IPID',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
            {
              STATUS: 'JSON_CONFIG.DETAIL_VIEW.GEBAEUDE.GUELTIGKEITSSTATUS',
              editable: false,
              max_length: 20,
              component: 'textview',
            },
          ],
        },
      ],
    },
    {
      fkArbeitsbereich: Workspace.nonWorkspace,
      fkIdentifyLayer: LayerCode.av_webgis_sw_liegenschaften,
      nonGuid: true,
      forms: [
        {
          fkIdentifyLayerId: 22,
          attributeTitle: 'BFSNR',
          detailViewTitle: 'IDENTIFY_CONFIG.PROJEKTIERTE_GRUNDSTUECKE',
          editable: false,
          editableLayerId: LayerCode.f_liegenschaften_proj_grundstuecke,
          formFields: [
            {
              objectid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.OBJECTID',
              editable: false,
            },
            {
              fileid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.FILEID',
              editable: false,
            },
            {
              kanton: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.KANTON',
              editable: false,
            },
            {
              gemeinde: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.GEMEINDE',
              editable: false,
            },
            {
              bfsnr: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.BFSNR',
              editable: false,
            },
            {
              objid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.OBJID',
              editable: false,
            },
            {
              projliegenschaft_von: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.PROJLIEGENSCHAFT_VON',
              editable: false,
            },
            {
              nummerteilgrundstueck: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.NUMMERTEILGRUNDSTUECK',
              editable: false,
            },
            {
              flaechenmass: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.FLAECHENMASS',
              editable: false,
            },
            {
              nummer: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.NUMMER',
              editable: false,
            },
            {
              egris_egrid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.EGRIS_EGRID',
              editable: false,
            },
            {
              art: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.ART',
              editable: false,
            },
            {
              art_txt: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.ART_TXT',
              editable: false,
            },
          ],
        },
        {
          fkIdentifyLayerId: 23,
          attributeTitle: 'BFSNR',
          detailViewTitle: 'IDENTIFY_CONFIG.PROJEKTIERTE_SELBSTAENDIGE_RECHTE',
          editable: false,
          editableLayerId: LayerCode.f_liegenschaften_proj_selbst_rechte,
          formFields: [
            {
              objectid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.OBJECTID',
              editable: false,
            },
            {
              fileid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.FILEID',
              editable: false,
            },
            {
              kanton: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.KANTON',
              editable: false,
            },
            {
              gemeinde: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.GEMEINDE',
              editable: false,
            },
            {
              bfsnr: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.BFSNR',
              editable: false,
            },
            {
              objid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.OBJID',
              editable: false,
            },
            {
              projselbstrecht_von: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.PROJSELBSTRECHT_VON',
              editable: false,
            },
            {
              nummerteilgrundstueck: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.NUMMERTEILGRUNDSTUECK',
              editable: false,
            },
            {
              flaechenmass: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.FLAECHENMASS',
              editable: false,
            },
            {
              nummer: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.NUMMER',
              editable: false,
            },
            {
              egris_egrid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.EGRIS_EGRID',
              editable: false,
            },
            {
              art: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.ART',
              editable: false,
            },
            {
              art_txt: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.ART_TXT',
              editable: false,
            },
          ],
        },
        {
          fkIdentifyLayerId: 24,
          attributeTitle: 'BFSNR',
          detailViewTitle: 'IDENTIFY_CONFIG.GRUNDSTUECKE',
          editable: false,
          editableLayerId: LayerCode.f_liegenschaft_grundstuecke,
          formFields: [
            {
              objectid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.OBJECTID',
              editable: false,
            },
            {
              fileid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.FILEID',
              editable: false,
            },
            {
              kanton: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.KANTON',
              editable: false,
            },
            {
              gemeinde: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.GEMEINDE',
              editable: false,
            },
            {
              bfsnr: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.BFSNR',
              editable: false,
            },
            {
              objid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.OBJID',
              editable: false,
            },
            {
              liegenschaft_von: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.LIEGENSCHAFT_VON',
              editable: false,
            },
            {
              nummerteilgrundstueck: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.NUMMERTEILGRUNDSTUECK',
              editable: false,
            },
            {
              flaechenmass: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.FLAECHENMASS',
              editable: false,
            },
            {
              nummer: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.NUMMER',
              editable: false,
            },
            {
              egris_egrid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.EGRIS_EGRID',
              editable: false,
            },
            {
              art: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.ART',
              editable: false,
            },
            {
              art_txt: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.ART_TXT',
              editable: false,
            },
          ],
        },
        {
          fkIdentifyLayerId: 25,
          attributeTitle: 'BFSNR',
          detailViewTitle: 'IDENTIFY_CONFIG.SELBSTAENDIGE_RECHTE',
          editable: false,
          editableLayerId: LayerCode.f_liegenschaften_selbststaendige_rechte,
          formFields: [
            {
              objectid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.OBJECTID',
              editable: false,
            },
            {
              fileid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.FILEID',
              editable: false,
            },
            {
              kanton: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.KANTON',
              editable: false,
            },
            {
              gemeinde: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.GEMEINDE',
              editable: false,
            },
            {
              bfsnr: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.BFSNR',
              editable: false,
            },
            {
              objid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.OBJID',
              editable: false,
            },
            {
              selbstrecht_von: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.SELBSTRECHT_VON',
              editable: false,
            },
            {
              nummerteilgrundstueck: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.NUMMERTEILGRUNDSTUECK',
              editable: false,
            },
            {
              flaechenmass: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.FLAECHENMASS',
              editable: false,
            },
            {
              nummer: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.NUMMER',
              editable: false,
            },
            {
              egris_egrid: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.EGRIS_EGRID',
              editable: false,
            },
            {
              art: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.ART',
              editable: false,
            },
            {
              art_txt: 'JSON_CONFIG.DETAIL_VIEW.NONWORKSPACE.ART_TXT',
              editable: false,
            },
          ],
        },
      ],
    },
  ],
};
